import { render, staticRenderFns } from "./TurnoDetalle.vue?vue&type=template&id=dcfb1512&"
import script from "./TurnoDetalle.vue?vue&type=script&lang=js&"
export * from "./TurnoDetalle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports